<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="option_breadcrumb" />
    </div>

    <div class="header">
      <h1 class="overlay">OPTION PROGRAM</h1>
      <!--      <img src="@/assets/images/Podohotel/hotspring_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container">
      <div class="row d-flex justify-content-center">
        <!--        <div>-->
        <!--          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />-->
        <!--        </div>-->
        <div class="col-lg-12 rowSpace"></div>
        <div class="text-center col-lg-12 mainTitle">{{ $t('snap_title') }}</div>
        <div class="mainTitleLine">
          <hr />
        </div>
        <div class="col-lg-12 text-center mainIntro">{{ $t('snap_subtitle') }}</div>
        <div class="rowSpace"></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
        </div>
        <div class="rowSpace"><hr /></div>
        <GallerySlideCarousels :slides="main_slides" :slide-count="4" :thumb-slide-width="45" />
      </div>
    </div>
    <div class="container subContainer">
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 mainInfo">
          <div class="subDetail" v-html="$t('snap_desc')"></div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('snap_program_title') }}</div>

          <table class="col-lg-12 table table-bordered subTable">
            <thead>
              <tr>
                <td style="width: 40%">{{ $t('snap_table_tr1_td1') }}</td>
                <td style="width: 30%">{{ $t('snap_table_tr1_td2') }}</td>
                <td style="width: 30%">{{ $t('snap_table_tr1_td3') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('snap_table_tr2_td1') }}</td>
                <td>-</td>
                <td>{{ $t('snap_table_tr2_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('snap_table_tr3_td1') }}</td>
                <td>-</td>
                <td>{{ $t('snap_table_tr3_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('snap_table_tr4_td1') }}</td>
                <td>-</td>
                <td>{{ $t('snap_table_tr4_td2') }}</td>
              </tr>
            </tbody>
          </table>
          <div class="etcDetail">{{ $t('snap_table_desc') }}</div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('snap_combi_title') }}</div>
          <ol>
            <li>{{ $t('snap_combi_desc1') }}</li>
            <li>{{ $t('snap_combi_desc2') }}</li>
            <li>{{ $t('snap_combi_desc3') }}</li>
          </ol>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('snap_reserve_title') }}</div>
          <ol>
            <li>{{ $injectEmails($t('snap_reserve_desc1')) }}</li>
            <li>{{ $t('snap_reserve_desc2') }}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';

export default {
  name: 'Snappicture',
  data() {
    return {
      isLang: 0,
      option_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      },
      main_slides: [
        {image: require('@/assets/images/pleisure/option/snappicture_01.jpg')},
        {image: require('@/assets/images/pleisure/option/snappicture_02.jpg')},
        {image: require('@/assets/images/pleisure/option/snappicture_03.jpg')},
        {image: require('@/assets/images/pleisure/option/snappicture_04.jpg')},
      ],
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: '스냅 사진'});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }
      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  components: {Breadcrumb, GallerySlideCarousels},
};
</script>

<style scoped lang="scss">
td {
  vertical-align: middle;
}
li {
  list-style-type: square;
  font-size: 0.9rem;
}

.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
.mainTitle {
  font-weight: 800;
  font-size: 2rem;
  letter-spacing: -0.1rem;
}
.mainTitleLine {
  width: 10%;
  > hr {
  }
}
.mainIntro {
  word-break: keep-all;
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff;
  }
  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
.subContainer {
  width: 100%;
}
.mainInfo {
  padding: 1rem;
  width: 100%;
  height: 100%;
  > div {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
.serviceArea {
  padding: 1rem;
  > span {
    font-size: 0.8rem;
  }
}
.subTitle {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.subDetail {
  font-size: 0.9rem;
  padding-left: 1rem;
  word-break: keep-all;
}
.etcDetail {
  font-size: 0.8rem;
  padding-left: 1rem;
  color: #616161;
}
.subTable {
  > thead {
    background-color: #eaeaea;

    > tr > td {
      width: 50%;
      text-align: center;
      font-weight: 600;
    }
  }
  > tbody {
    > tr > td {
      text-align: center;
      font-size: 0.9rem;
    }
  }
  margin-bottom: 0.5rem;
}

.rowSpace {
  width: 100%;
  height: 2rem;
  > hr {
  }
}

@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/common/option_headerimage.jpg');
  }
  .web {
    display: block;
  }
  .mobile {
    display: none;
  }
  .tHeader {
    font-size: 1.1rem;
  }
  .tBody {
    font-size: 1rem;
  }
}
@media (max-width: 992px) {
  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: bold;
    }
  }
  .headerimage {
    display: none;
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "옵션 프로그램",
    "snap_title": "스냅 사진",
    "snap_subtitle": "잊지 못할 소중한 추억을 전문가의 손길로 남겨보세요.",
    "prev_button": "이전",
    "snap_desc": "가족, 소중한 사람들과 함께 하는 잊지 못할 추억을 전문가의 사진으로 남겨보세요.<br/>전문 사진작가가 레저를 동행하며 고객님의 순간순간을 소중히 담아 드립니다.<br/>레저를 하는 멋진 모습이 담긴 사진은 색다른 추억을 선사 해 드릴 것입니다.",
    "snap_program_title": "운영 프로그램",
    "snap_table_tr1_td1": "프로그램",
    "snap_table_tr1_td2": "옵션",
    "snap_table_tr1_td3": "요금",
    "snap_table_tr2_td1": "요트 스냅",
    "snap_table_tr2_td2": "500,000 ~",
    "snap_table_tr3_td1": "골프 스냅",
    "snap_table_tr3_td2": "350,000 ~",
    "snap_table_tr4_td1": "승마 스냅",
    "snap_table_tr4_td2": "150,000 ~",
    "snap_table_desc": "※ P-Leisure 메인프로그램 이용 시 적용되는 특별가 입니다.",
    "snap_combi_title": "결합 가능한 P-Leisure 메인 프로그램",
    "snap_combi_desc1": "프라이빗 럭셔리요트",
    "snap_combi_desc2": "챌린저 골프",
    "snap_combi_desc3": "노블승마",
    "snap_reserve_title": "예약문의 및 상담",
    "snap_reserve_desc1": "064-793-7070, 010-5328-7050, [[EMAIL:leisure]]",
    "snap_reserve_desc2": "월~금(공휴일 제외) 09:00 ~ 17:30 (점심시간 12:00 ~ 13:00)"
  },
  "en": {
    "breadcrumb": "Option Program",
    "snap_title": "Snap Shot",
    "snap_subtitle": "Keep unforgettable memories with a professional photographer.",
    "prev_button": "Previous",
    "snap_desc": "Take a picture with a professional photographer to keep the unforgettable memory with your family and loved ones.<br/>A professional photographer will accompany you on leisure activities and cherish your moments in photos.<br/>Photos of you enjoying leisure activities will be a special memory for you.",
    "snap_program_title": "Program",
    "snap_table_tr1_td1": "Program",
    "snap_table_tr1_td2": "Option",
    "snap_table_tr1_td3": "Fare",
    "snap_table_tr2_td1": "Yacht Snapshot",
    "snap_table_tr2_td2": "KRW 500,000 ~",
    "snap_table_tr3_td1": "Golf Snapshot",
    "snap_table_tr3_td2": "KRW 350,000 ~",
    "snap_table_tr4_td1": "Horse riding Snapshot",
    "snap_table_tr4_td2": "KRW 150,000 ~",
    "snap_table_desc": "※ Special price for P-Leisure users",
    "snap_combi_title": "Combinable programs",
    "snap_combi_desc1": "private luxury yacht",
    "snap_combi_desc2": "challenger golf",
    "snap_combi_desc3": "noble riding",
    "snap_reserve_title": "Reservation",
    "snap_reserve_desc1": "064-793-7070, 010-5328-7050, [[EMAIL:leisure]]",
    "snap_reserve_desc2": "MON~Sun (Excluding public holidays) 09:00 ~17:30 (Lunch 12:00 ~13:00)"
  },
  "ja": {

  }
}
</i18n>
